import React from "react"
import CapDivider from "../../CapDivider"
import { clsPrefix, MESSAGE_LIKE, MESSAGE_DISLIKE } from './constants';
import classNames from "classnames"

// meta data displayed at the end of answer
export const MetaDataBlock = ({
  metaData = {},
  likeAnswer = () => { },
  dislikeAnswer = () => { },
  rating,
  textLinks,
  textConfidence,
  textWasHelpful,
}) => {
  const { sources = [], confidence = "" } = metaData;
  return (
    <div className={`${clsPrefix}-meta-data`}>
      <div className={`${clsPrefix}-links`}>
        <div className={`${clsPrefix}-link-label`}>{textLinks}</div>
        {sources.map((link, i) => (
          <a key={i} href={link} target="_blank">
            {link}
          </a>
        ))}
      </div>
      <div className={`${clsPrefix}-feedback`}>
        <span className={`${clsPrefix}-confidence`} data-level="high">
          {confidence}% {textConfidence}
        </span>
        <CapDivider type="vertical" />
        {textWasHelpful}
        <span
          className={classNames(`${clsPrefix}-rate-answer`, `${clsPrefix}-like`)}
          data-selected={rating === MESSAGE_LIKE}
          onClick={likeAnswer}
        >
          👍
        </span>
        <span
          className={classNames(`${clsPrefix}-rate-answer`, `${clsPrefix}-dislike`)}
          data-selected={rating === MESSAGE_DISLIKE}
          onClick={dislikeAnswer}
        >
          👎
        </span>
      </div>
    </div>
  );
}
